<template>
  <div>
    <div class="base-margin__bottom-10 base-flex">
      <el-select v-model="userId" :placeholder="$t('describeOperation.selectUser')" class="select-width__230"
                 clearable @change="getList">
        <el-option
          v-for="item in userList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
          <span>{{ item.name }} {{ `${item.remark !== '' ? `(${item.remark})` : ''}` }}</span>
        </el-option>
      </el-select>
      <el-select v-model="operationKeys" :placeholder="$t('describeOperation.selectOperationType')"
                 class="select-width__230" clearable
                 @change="getList">
        <el-option
          v-for="item in operationKeysList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </div>
    <div class="table">
      <el-table :data="tableData" class="table_width">
        <el-table-column :label="$t('describeOperation.id')" prop="id" width="100"></el-table-column>
        <el-table-column :label="$t('describeOperation.userName')">
          <template slot-scope="scope">
            <span>{{
                scope.row.userInfo.name
              }} {{ `${scope.row.userInfo.remark !== '' ? `(${scope.row.userInfo.remark})` : ''}` }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('describeOperation.operationName')" prop="name"></el-table-column>
        <el-table-column :label="$t('describeOperation.loginIp')" prop="loginIp"></el-table-column>
        <el-table-column :label="$t('describeOperation.remark')" prop="remark"></el-table-column>
        <el-table-column :label="$t('describeOperation.createTime')" prop="createTime" width="220"></el-table-column>
        <el-table-column
          :label="$t('describeOperation.actions')"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="detailInfo(scope.row.content)">{{
                $t('describeOperation.details')
              }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('describeOperation.details')"
      :visible.sync="dialogVisible"
      destroy-on-close
      width="500"
      @close="closeDialog"
    >
      <template>
        <div style="border: 1px solid #ccc;">
          <Toolbar
            :defaultConfig="toolbarConfig"
            :editor="editor"
            style="border-bottom: 1px solid #ccc"
          />
          <!-- 编辑器 -->
          <Editor
            v-model="contentInfo"
            :defaultConfig="editorConfig"
            style="height: 400px; overflow-y: hidden"
            @onCreated="onCreated"
          />
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {Editor, Toolbar} from '@wangeditor/editor-for-vue';
import {getRequest} from '@/common/libs/request';

export default {
  name: 'describeOperation',
  components: {Editor, Toolbar},
  data() {
    return {
      editor: null,
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        // excludeKeys: [ /* 隐藏哪些菜单 */ ],
      },
      editorConfig: {
        placeholder: this.$t('describeOperation.enterContent'),
        // autoFocus: false,

        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {},
      },
      tableData: [], // 用户操作列表
      projectOptions: [],
      userId: '0', // 用户ID
      userList: [], // 用户列表
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
      contentInfo: '',
      dialogVisible: false,
      operationKeysList: [], // 操作列表
      operationKeys: '', // 操作类型
    };
  },
  created() {
    this.getUserList();  // 获取用户列表
    this.getOperationKeys(); // 获取操作列表
    this.getList();
  },

  methods: {
    /**
     * 查询用户操作列表
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      if (this.userId === '') {
        this.userId = '0';
      }
      getRequest(`/api/eda/common/admin/describeOperation?offset=${offset}&limit=${this.pageLimit}&userId=${this.userId}&name=${this.operationKeys}`).then((res) => {
        this.tableData = res?.list || [];
        this.tableDataTotal = res?.total || 0;
      });
    },
    /**
     * 获取详细信息
     */
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },

    detailInfo(content) {
      this.dialogVisible = true;
      const jsonObj = JSON.parse(content);   // 把json字符串转为json对象
      const JsonContent = JSON.stringify(jsonObj, null, 4);
      this.contentInfo = JsonContent;
    },

    closeDialog() {
      const {editor} = this;
      if (editor == null) return;
      editor.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
    },

    /**
     * 查询用户操作列表
     */
    getUserList() {
      getRequest('/api/eda/common/admin/getUserList?offset=0&limit=999').then((res) => {
        res?.list.unshift({
          id: '0',
          name: this.$t('describeOperation.all'),
          remark: '',
        });
        this.userList = res?.list;
      });
    },

    /**
     * 获取操作列表
     */
    getOperationKeys() {
      getRequest('/api/common/getSetting?key=operation_keys').then((res) => {
        this.operationKeysList = res?.split(',') || [];
      });
    },

    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}

.select-width__230 {
  width: 230px !important;
  margin-right: 10px;
}
</style>
